<template>
  <div class="google-pay-method">
    <div class="method" :class="{ noClick: loadingShow }" @click="handleGooglePay" v-if="price">
      <div class="methods">
        <div class="method-img"><img src="@/assets/packageAssets/common/google.png" alt="" /></div>
        <div class="line"></div>
        <div class="method-name">
          <span>Google Pay</span>
          <div class="rate">
            <!-- prettier-ignore -->
            <div class="pay-price" v-if="price">
              <i>{{ currency }}</i><span>{{ price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loadingShow: {},
    price: {},
    currency: {},
  },
  data() {
    return {}
  },
  methods: {
    handleGooglePay() {
      // 与echo的不同
      this.$emit('googlePay')
    },
  },
}
</script>

<style lang="less" scoped>
.google-pay-method {
  .method {
    width: 100%;
  }
  .methods {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 8px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;

    .method-img {
      display: flex;
      justify-content: center;
      > img {
        height: 32px;
        object-fit: contain;
      }
    }
    .line {
      height: 20px;
      margin: 0 5px;
      border-right: 1px solid #d8d8d8;
    }
    .method-name {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-600);
      line-height: var(--lh-label-18);
      color: #333333;

      .rate {
        display: flex;
        align-items: center;
        .pay-price {
          position: relative;
          // height: 36px;
          padding: 8px 5px;
          // line-height: 36px;
          background: #424145;
          border-radius: 6px;
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-600);
          line-height: var(--lh-body-20);
          color: #ffd786;
          text-align: center;
          i {
            font-family: var(--string-font);
            font-size: var(--fs-10);
            font-weight: var(--fw-600);
            line-height: var(--lh-label-14);
          }
        }
        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .actTextColor {
          opacity: 0.1;
        }
      }
    }
  }
  .noClick {
    pointer-events: none;
  }
}
</style>
